import axios from '../config/axiosConfig';

const tenantService = {
  // ==================== Public (no auth) ====================

  /**
   * Resolve tenant branding by subdomain (public, used before login)
   */
  async resolveTenant(subdomain) {
    const response = await axios.get(`/tenants/resolve/${subdomain}`);
    return response.data;
  },

  // ==================== Super Admin - Tenant CRUD ====================

  /**
   * List all tenants with stats (super admin only)
   */
  async getTenants() {
    const response = await axios.get('/tenants');
    return response.data;
  },

  /**
   * Get a single tenant by ID (super admin only)
   */
  async getTenant(id) {
    const response = await axios.get(`/tenants/${id}`);
    return response.data;
  },

  /**
   * Create a new tenant with optional initial admin user (super admin only)
   */
  async createTenant(tenantData) {
    const response = await axios.post('/tenants', tenantData);
    return response.data;
  },

  /**
   * Update a tenant (super admin only)
   */
  async updateTenant(id, tenantData) {
    const response = await axios.put(`/tenants/${id}`, tenantData);
    return response.data;
  },

  /**
   * Deactivate a tenant (super admin only)
   */
  async deactivateTenant(id) {
    const response = await axios.delete(`/tenants/${id}`);
    return response.data;
  },

  // ==================== Tenant Settings (tenant_admin) ====================

  /**
   * Get current tenant settings
   */
  async getTenantSettings() {
    const response = await axios.get('/tenant-settings');
    return response.data;
  },

  /**
   * Update tenant branding
   */
  async updateBranding(brandingData) {
    const response = await axios.put('/tenant-settings/branding', brandingData);
    return response.data;
  },

  /**
   * Upload tenant logo
   */
  async uploadLogo(logoData) {
    const response = await axios.post('/tenant-settings/logo', logoData);
    return response.data;
  },

  /**
   * Remove tenant logo
   */
  async removeLogo(type) {
    const response = await axios.delete(`/tenant-settings/logo/${type}`);
    return response.data;
  }
};

export default tenantService;
